import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useLetterDetail = (id) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["letterDetail", tenantVal, id],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientletter/get/${id}`
      );

      return response.data;
    },
    enabled: !!id && !!tenantVal,
    meta: { skipGlobalError: true },
  });
};
